<template>
  <div class="teamCenter clearfix">

    <div class="titleBox">
      <h2>发票管理</h2>
      <p>未开发票的订单可以在我的订单内申请开票（普票）</p>
    </div>
    <div class="searchBox">
      <div class="box riqi">
        <div class="form-group m-0">
          <label>日期选择</label>
          <div class="zujian">
            <date-range-picker
              ref="picker"
              :opens="opens"
              :locale-data="localeData"
              :minDate="minDate" :maxDate="maxDate"
              :singleDatePicker="singleDatePicker"
              :timePicker="timePicker"
              :timePicker24Hour="timePicker24Hour"
              :showWeekNumbers="showWeekNumbers"
              :showDropdowns="showDropdowns"
              :autoApply="autoApply"
              v-model="dateRange"
              @update="updateValues"
              @toggle="logEvent('event: open', $event)"
              @start-selection="logEvent('event: startSelection', $event)"
              @finish-selection="logEvent('event: finishSelection', $event)"
              :linkedCalendars="linkedCalendars"
            >
            </date-range-picker>
            <i @click="clearDateTangeFun" class="iconfont icon-guanbi clear"></i>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>申请编号</label>
          <input @input="initData(true)" v-model="no" type="text" class="form-control">
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>关联订单/出库号</label>
          <input @input="initData(true)" v-model="containOrderNo" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="box">
        <div class="form-group m-0">
          <label>包含商品名称</label>
          <input @input="initData(true)" v-model="containGoodsName" type="text" class="form-control" placeholder="">
        </div>
      </div>
      <div class="box shenqingBox">
        <button @click="showModelBox('store')" class="btn btn-outline-light"><i class="iconfont icon-plus"></i> 开票申请</button>
      </div>
    </div>
    <div class="jiazaiBox" v-if="intLoading">
      <div class="spinner-border text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="threeBox" v-if="!intLoading">
      <div v-if="!is_loading" class="box yuanjiao">
        <ul>
          <li v-for="(app,index) in data" :key="index" class="huanchongZhong cursor" @click="showModelBox('content',app.id)">
            <div class="kuaiBox">
              <h3 class="mb-3">
                <b>日期：{{app.addtime_ymd}}</b>
                <span class="badge badge-danger" v-if="app.is_state==='1'">处理中</span>
                <span class="badge badge-primary" v-if="app.is_state==='2'">已完成</span>
                <span class="badge badge-secondary" v-if="app.is_state==='3'">已取消</span>
              </h3>
              <div class="show mb-3">
                <div>{{app.invoiceFrom==='1'?'个人':'企业'}} - {{app.invoiceType==='1'?'电子普通发票':'纸质增值税专用发票'}}</div>
                <div>实付税额：￥{{app.tax}}</div>
                <div>支付方式：{{app.payment_proceeds_title && app.tax*1!=0?app.payment_proceeds_title:'免支付'}}</div>
                <div>发票面额：￥{{app.totalSum}}</div>
              </div>
              <div class="content orderNo">
                <p class="mb-1">申请编号：{{app.no}}</p>
                包含商品：{{app.containGoodsName}}
              </div>
            </div>
          </li>
        </ul>
        <br>
        <div class="description text-center">
          <div v-if='isLoading && page!==1' class='dynamicMessage'>
            <i class='iconfont icon-jiazai xuanzhuan' style="font-size: 28px;"></i>
          </div>
          <div v-if='isNodata' class='dynamicMessage'>
            — 没有更多了 —
          </div>
          <div v-if='isError' class='dynamicMessage'>
            — 请求失败 —
          </div>
          <br>
          <br>
          <br>
          <br>
          <br>
        </div>
      </div>
      <div v-if="data.length===0" class="emptyBox yuanjiao">
        <i class="iconfont icon-wushuju content"></i>
      </div>
    </div>

    <transition leave-active-class='animated animated2 slideOutRight'>
      <div v-if="isShowRightBox" class="rightBoxModel huanchong" @click.self="closeRightBoxFun(false)">
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <component :closeRightBoxFun="closeRightBoxFun" :parameter="parameter" :is="isCompnentElement"></component>
        </transition>
        <transition appear mode='out-in' enter-active-class='animated animated2 slideInRight' leave-active-class='animated animated2 slideOutRight'>
          <span class="guanbiBtn cursor huanchongKuai" @click="closeRightBoxFun(false)">
            <i class="iconfont icon-icon-arrow-right2"></i>
          </span>
        </transition>
      </div>
    </transition>
  </div>
</template>

<script>
// import { EventBus } from '@/util/eventBus';
import generalMix from '@/util/mix/general';
import uiInvoiceStore from '@/components/common/invoice/Store';
import uiInvoiceContent from '@/components/common/invoice/Content';
import resultCommons from '@/util/resultcommons';
import commons from '@/util/commons';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'teamCenter',
  mixins: [generalMix],
  data () {
    return {
      isShowRightBox: false,
      isCompnentElement: '',
      parameter: {},
      ossImgDomain: process.env.OSS_IMG_DOMAIN,
      // 条件
      no: '',
      containOrderNo: '',
      containGoodsName: '',
      // 时间筛选
      opens: 'right',
      minDate: null, // 最小时间
      maxDate: null, // 最大时间
      singleDatePicker: false, // 范围为false
      timePicker: false, // 是否选择小时和分钟
      timePicker24Hour: true, // 24小时制
      showWeekNumbers: true, // 左侧显示周数
      showDropdowns: true, // 显示下拉选择 快速选择年份和月份
      autoApply: true, // 第二次点击自动选择
      dateRange: {
        startDate: null,
        endDate: null
      }, // 时间值
      linkedCalendars: true, // 每个日历都有单独的导航
      localeData: {
        firstDay: 1,
        format: 'yyyy-mm-dd',
        separator: ' 至 ',
        applyLabel: '确定',
        cancelLabel: '取消',
        daysOfWeek: ['日', '一', '二', '三', '四', '五', '六'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
      },
      // 分页
      data: [], // 数据队列
      allPage: 1, // 总页数
      allNumber: 0,
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      intLoading: true, // 初始化加载
      is_loading: false
    }
  },
  computed:{
    whereObj() {
      return {
        page: this.page,
        no: this.no,
        containOrderNo: this.containOrderNo,
        containGoodsName: this.containGoodsName,
        startTime: commons.getData(this.dateRange.startDate),
        endTime: commons.getData(this.dateRange.endDate)
      };
    }
  },
  methods:{
    clearDateTangeFun() {
      if(this.dateRange.startDate || this.dateRange.endDate){
        this.dateRange = {startDate: null, endDate: null};
        this.initData();
      }
    },
    // 更新了日期
    updateValues() {
      this.initData();
    },
    logEvent(message, event) {
    },
    // 关闭
    closeRightBoxFun(reload = false) {
      this.isShowRightBox = false;
      this.parameter = {};
      this.isCompnentElement = '';
      $('html').removeClass('scrollHide');
      if(reload){
        this.initData(true)
      }
    },
    // 显示模态框
    showModelBox(type,id = '') {
      if(type === 'store'){
        this.isCompnentElement = 'ui-invoice-store';
      }else{
        this.parameter = {token:id};
        this.isCompnentElement = 'ui-invoice-content';
      }
      $('html').addClass('scrollHide');
      this.isShowRightBox = true;
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
      }
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = commons.scrollToButton() <= 150;
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          const whereJson = that.whereObj;
          whereJson.startTime = that.$refs.startTimeNode.value;
          whereJson.endTime = that.$refs.endTimeNode.value;
          resultCommons.apiInvoicelists(that, whereJson).then((ob) => {
            console.log(ob, this.page);
          });
        }
      };
    },
    initData(bool = false){
      if(bool){
        this.intLoading = true;
      }
      // 执行搜索
      this.loadingFun(2);
      // 初始化
      this.data = [];
      this.allPage = 1;
      this.page = 1;
      // 不为空
      this.is_empty = false;
      const whereJson = this.whereObj;
      // 执行搜索
      resultCommons.apiInvoicelists(this, whereJson).then((ob) => {}).then(app=>{
        if(bool){
          this.intLoading = false;
        }
      });
    }
  },
  components: {
    'ui-invoice-store':uiInvoiceStore,
    'ui-invoice-content':uiInvoiceContent,
    DateRangePicker
  },
  mounted() {
    this.initData(true);
    this.scroll(this, window);
    $('html').removeClass('scrollHide');
  },
  beforeDestroy() {
    // 清除事件
    window.onscroll = null;
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.teamCenter {
  color: #000000;
  .titleBox {
    margin-top: 30px;
    color: #FFFFFF;
    margin-bottom: 30px;
    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.5);
    }
  }
  div.searchBox{
    margin-bottom: 20px;
    display: flex;
    div.box{
      flex: 1;
      margin-right: 15px;
      div.form-group{
        height: 59px;
      }
      label{
        color: #FFFFFF;
      }
      &:last-child{
        margin: 0;
      }
      &.shenqingBox{
        display: flex;
        justify-content: end;
        align-items: end;
      }
      &.riqi{
        flex: auto;
        div.zujian{
          position: relative;
          .vue-daterange-picker{
            width: 100%;
          }
          i.clear{
            position: absolute;
            right: 5px;
            top: 8px;
            color: rgba(0,0,0,0.4);
            cursor: pointer;
            &:hover{
              color: rgba(0,0,0,1);
            }
          }
        }
      }
    }
  }
  div.jiazaiBox{
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
    background: #FFFFFF;
    min-height: 80vh;
    .spinner-border{
      width: 3rem;
      height: 3rem;
      color: red;
    }
  }
  div.threeBox {
    color: #000000;
    div.box {
      background: #FFFFFF;
      padding: 20px 0;
      padding-top: 0;
      overflow-y: hidden;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.2);
      min-height: 100vh;
      ul{
        margin-bottom: 50px;
        li{
          display: flex;
          align-items: center;
          border-bottom: 1px solid #E5E5E5;
          padding: 20px 20px;
          background: #FFFFFF;
          &:hover{
            background: #F9F9F9;
          }
          &:nth-child(even){
            background: #F5F5F7;
          }
          .kuaiBox{
            display: flex;
            flex-direction: column;
            overflow: hidden;
            flex: 1;
            h3{
              font-size: 18px;
              font-weight: bold;
              display: flex;
              justify-content: space-between;
              span{
                padding-top: 4px;
              }
            }
            div.show{
              display: flex;
              div{
                flex: 1;
              }
            }
            div.orderNo{
              word-break:break-all;
              word-wrap:break-word;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .teamCenter{
    div.threeBox {
      div.box {
        ul{
          li{
            padding: 30px 30px;
          }
        }
      }
    }
  }
}

@media (max-width: 767px) {
  .teamCenter{
    .titleBox {
      margin-top: 50px;
      text-align: center;
      p{
        padding: 0 15px;
      }
    }
    div.searchBox{
      flex-direction: column;
      div.box{
        margin-right: 0;
        margin-bottom: 10px;
        &:last-child{
          button.btn{
            width: 100%;
          }
        }
        .btn{
          width: 100%;
        }
      }
    }
    div.threeBox{
      div.box{
        ul{
          li{
            .kuaiBox{
              h3{
                display: block;
                div{
                  border-bottom: 1px solid #CCCCCC;
                  font-size: 18px;
                  margin-bottom: 10px;
                  line-height: 2em;
                }
              }
              div.show{
                flex-direction: column;
                margin: 0 !important;
                div{
                  margin-bottom: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/invoice/Center.vue